<template>
    <div class="flex flex-col gap-5">
      <div class="p-2">
        <p class="text-md text-gray-800">{{ props.data.message }}</p>
        <ul class="list-disc pl-5 my-4">
          <li
            v-for="(name, idx) in props.data.expired"
            :key="idx"
            class="text-gray-700 text-md my-2"
          >
            {{ name }}
          </li>
        </ul>
      </div>
  
      <div class="flex justify-center gap-4 mt-2">
        <template v-if="props.data.type === 'partial'">
          <UButton size="xl" label="Cancel" class="px-8" @click="emit('close')" />
          <UButton
            size="xl"
            label="Remove"
            variant="outline"
            class="px-8"
            @click="emit('partialconfirm')"
          />
        </template>
        <template v-else>
          <UButton
            size="xl"
            label="Okay"
            class="px-8"
            @click="emit('fullclose')"
          />
        </template>
      </div>
    </div>
  </template>
  
  <script setup>
  const emit = defineEmits(['close', 'fullclose', 'partialconfirm']);
  const props = defineProps(['data']);
  </script>